import React from "react";
import { MerchantBellIcon } from "./MerchantIcons";

export default function MerchantMobileHeader({
  avatarText,
  pageLabel,
  pageTitle,
  onOpenDrawer,
}) {
  return (
    <header className="merchant-mobile-header">
      <button
        className="merchant-mobile-hamburger"
        type="button"
        aria-label="Open merchant menu"
        onClick={onOpenDrawer}
      >
        <span className="merchant-mobile-hamburger-line" />
        <span className="merchant-mobile-hamburger-line merchant-mobile-hamburger-line-short" />
        <span className="merchant-mobile-hamburger-line" />
      </button>

      <div className="merchant-mobile-header-title-area">
        <div className="merchant-mobile-header-label">{pageLabel}</div>
        <div className="merchant-mobile-header-title">{pageTitle}</div>
      </div>

      <div className="merchant-mobile-header-actions">
        <div className="merchant-mobile-notification">
          <button className="merchant-mobile-icon-button" type="button" aria-label="Notifications">
            <MerchantBellIcon />
          </button>
          <span className="merchant-mobile-notification-dot" />
        </div>
        <div className="merchant-mobile-avatar">{avatarText}</div>
      </div>
    </header>
  );
}
